import { AppMultiSelect, AppRemixIcon } from '@/layout/AppComponents';
import axios from 'axios';
import { useCallback, useEffect, useState } from 'react';
import ReactDOMServer from 'react-dom/server';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { axiosPath } from '../../../../routing/helpers/router';
import ErrorHandler from '../../error/ErrorHandler';
import Translator from '../../helpers/Translator';
import useIsMounted from '../../hooks/useIsMounted';

export default function ResourceManagerSelectPlants(props) {
  const {
    onHandleChange,
    value,
    error,
    title = <Translator file="user" name="user.plants" />,
    className = 'mb-2',
  } = props;
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const [options, setOptions] = useState([]);

  const loadPlants = useCallback(
    async () =>
      axios
        .post(
          axiosPath('api_r_user_module_resourceManager_getPlants'),
          {
            moduleBridgeHex,
          }
        )
        .then(({ data }) => {
          if (isMounted.current) {
            setOptions(data);
          }
        })
        .catch((e) => dispatch(ErrorHandler(e))),

    []
  );

  useEffect(() => {
    setOptions(null);
    loadPlants();
  }, []);

  return (
    <AppMultiSelect
      icon={<AppRemixIcon icon="building-4" />}
      options={options}
      title={title}
      placeholder={ReactDOMServer.renderToString(
        <Translator file="user" name="select.one.or.multiple.plants" />
      )}
      value={value ?? []}
      onChange={onHandleChange}
      isLoading={!options}
      className={className}
      error={error}
      hasSearchBox
      hasSelectOptions
    />
  );
}
